import { stateful } from '@adornis/functional-lit/stateful.js';
import { html } from 'lit';

export type NoPermissionProps = {
  title?: string;
  message?: string;
};

export const NoPermission = stateful((props: NoPermissionProps) => {
  const title = props?.title ?? 'Keine Zugriffsrechte';
  const message = props?.message ?? 'Sie haben nicht die nötigen Berechtigungen, um auf diese Seite zuzugreifen.';

  return html`
    <div class="flex h-full w-full items-center justify-center p-4">
      <div class="flex max-w-md flex-col items-center text-center">
        <div class="mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-error/10">
          <span class="icon-[material-symbols--lock-outline] h-12 w-12 text-error"></span>
        </div>
        <h2 class="mb-2 font-semibold md:text-lg text-base-content">${title}</h2>
        <p class="text-base-content/70">${message}</p>
      </div>
    </div>
  `;
});
